// Las respuestas del asistente traen formato simple (negritas, listas, tablas con barras). Se convierten a bloques para
// que la pantalla los dibuje como elementos de React; nunca se inserta HTML, así que un texto raro no puede ejecutar nada.

const TABLE_SEPARATOR = /^\s*\|?\s*:?-{2,}:?\s*(\|\s*:?-{2,}:?\s*)*\|?\s*$/;

const splitRow = (line) => line.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map((cell) => cell.trim());

/** Parte un texto en partes `{ bold, text }` según los `**negritas**`. */
export const inlineParts = (text) =>
  String(text || '')
    .split(/(\*\*[^*]+\*\*)/g)
    .filter((part) => part !== '')
    .map((part) => (/^\*\*[^*]+\*\*$/.test(part) ? { bold: true, text: part.slice(2, -2) } : { bold: false, text: part }));

/**
 * Convierte el texto en bloques: `paragraph`, `heading`, `list` (con `ordered`) y `table`.
 * Las líneas vacías separan bloques; un texto sin formato queda como un párrafo por línea.
 */
export const parseAnswer = (text) => {
  const lines = String(text || '').replace(/\r/g, '').split('\n');
  const blocks = [];
  let i = 0;

  while (i < lines.length) {
    const line = lines[i];
    if (line.trim() === '') { i += 1; continue; }

    const heading = line.match(/^\s*#{1,6}\s+(.*)$/);
    if (heading) { blocks.push({ type: 'heading', text: heading[1] }); i += 1; continue; }

    if (line.includes('|') && i + 1 < lines.length && TABLE_SEPARATOR.test(lines[i + 1])) {
      const header = splitRow(line);
      const rows = [];
      i += 2;
      while (i < lines.length && lines[i].includes('|') && lines[i].trim() !== '') { rows.push(splitRow(lines[i])); i += 1; }
      blocks.push({ type: 'table', header, rows });
      continue;
    }

    const bullet = line.match(/^\s*[-*•]\s+(.*)$/);
    const numbered = line.match(/^\s*\d+[.)]\s+(.*)$/);
    if (bullet || numbered) {
      const ordered = Boolean(numbered);
      const items = [];
      while (i < lines.length) {
        const m = ordered ? lines[i].match(/^\s*\d+[.)]\s+(.*)$/) : lines[i].match(/^\s*[-*•]\s+(.*)$/);
        if (!m) break;
        items.push(m[1]);
        i += 1;
      }
      blocks.push({ type: 'list', ordered, items });
      continue;
    }

    blocks.push({ type: 'paragraph', text: line.trim() });
    i += 1;
  }
  return blocks;
};
